module.exports = __webpack_public_path__ + "static/media/screen7.6518f36b.png";